module.exports = __webpack_public_path__ + "img/uzb.e0da3f7b.svg";